/**
 * Generated by: /create-workflow-model http://localhost:4300/proxy/member/v1/selfservice-actions/correspondence --name correspondence --path libs/web/contact/src/lib/service
 * Generated on: 2025-12-22
 * Last updated: 2025-12-29
 *
 * This file was auto-generated. To regenerate with latest workflow data, run the command above.
 */

import { Injectable } from '@angular/core';
import {
  formFieldDate,
  formFieldString,
  ObjectWorkflowIntegrationFormField,
  TypedFormField,
  TypedFormTable,
  WorkflowIntegrationResponse,
  WorkflowIntegrationStep,
} from '@cassiopeia/integration';
import { RemoveIndexSignature } from '@nestech/utils';
import { SelfServiceWorkflowApi } from '../danish-pension'; // Type aliases for domain-specific usage

// Type aliases for domain-specific usage
export type CorrespondenceStep = WorkflowIntegrationStep;
export type CorrespondenceFormField = ObjectWorkflowIntegrationFormField;

// Step ID union type
export type CorrespondenceStepId = 'start';

// Chat message table row
export interface ChatMessage {
  readonly id?: string;
  timestamp: Date;
  author: string;
  message: string;
}

// Start step form field keys
export type StartFormFieldKey = keyof RemoveIndexSignature<StartStep['formFields']>;

// Start step form fields interface
export interface StartFormFields {
  topic: TypedFormField<string>;
}

// Start step form tables interface
export interface StartFormTables {
  chat: TypedFormTable<ChatMessage>;
}

// Sign step form field keys
export interface SignFormFields {
  signFileName: TypedFormField<string>;
}

// Start step interface with typed form fields and tables
export interface StartStep extends Omit<WorkflowIntegrationStep, 'formFields' | 'formTables'> {
  formFields: StartFormFields;
  formTables: StartFormTables;
}

export interface SignStep extends Omit<WorkflowIntegrationStep, 'formFields' | 'formTables'> {
  formFields: SignFormFields;
}

// Main Correspondence workflow interface
export interface Correspondence extends WorkflowIntegrationResponse {
  start: StartStep;
  sign: SignStep;
}

/**
 * Maps the raw WorkflowIntegrationResponse from the integration API
 * to a more strongly-typed Correspondence interface
 */
const mapApiToCorrespondence = (api: WorkflowIntegrationResponse): Correspondence => {
  const startStep = api.steps?.['start'];
  const signStep = api.steps?.['sign'];

  if (!startStep) throw new Error('start step is required');
  if (!signStep) throw new Error('sign step is required');

  return {
    ...api,
    start: {
      ...startStep,
      formFields: {
        topic: formFieldString('topic', startStep.formFields),
      },
      formTables: {
        chat: {
          ...startStep.formTables?.['chat'],
          formFields: {
            timestamp: formFieldDate('timestamp', startStep.formTables?.['chat']?.formFields),
            author: formFieldString('author', startStep.formTables?.['chat']?.formFields),
            message: formFieldString('message', startStep.formTables?.['chat']?.formFields),
          },
          tableData:
            startStep.formTables?.['chat']?.tableData?.map(row => ({
              id: row['id'],
              timestamp: row['timestamp'],
              author: row['author'],
              message: row['message'],
            })) || [],
        } as TypedFormTable<ChatMessage>,
      },
    },
    sign: {
      ...signStep,
      formFields: {
        signFileName: formFieldString('signFileName', signStep.formFields),
      },
    },
  };
};

@Injectable({ providedIn: 'root' })
export class CorrespondenceApi extends SelfServiceWorkflowApi<Correspondence> {
  override mapToModel(response: WorkflowIntegrationResponse): Correspondence {
    return mapApiToCorrespondence(response);
  }

  override actionName = 'correspondence';
}
